// Must stay the first import: it moves a Microsoft sign-in response off "/" before the router reads the URL.
import './app/entra-return';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './app/auth';
import { ToastProvider } from './app/toast';
import { router } from './app/routes';
import { ApiError } from './lib/api';
import { applyTheme, readThemePref } from './lib/theme';
import './styles/index.css';

applyTheme(readThemePref());
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  if (readThemePref() === 'system') applyTheme('system');
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Retry only transient failures; a 4xx will not fix itself.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
